var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgInfoIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 0.959961C5.90258 0.959961 0.960022 5.90252 0.960022 12C0.960022 18.0974 5.90258 23.04 12 23.04C18.0975 23.04 23.04 18.0974 23.04 12C23.04 5.90252 18.0975 0.959961 12 0.959961ZM12 5.27996C12.7954 5.27996 13.44 5.9246 13.44 6.71996C13.44 7.51532 12.7954 8.15996 12 8.15996C11.2047 8.15996 10.56 7.51532 10.56 6.71996C10.56 5.9246 11.2047 5.27996 12 5.27996ZM13.92 18.24H12.96H11.04H10.08V17.28H11.04V11.04H10.08V10.08H11.04H12.96V11.04V17.28H13.92V18.24Z",
    fill: "#00B0A6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfoIcon);
export default __webpack_public_path__ + "static/media/info_icon.c73f519ee63e67489bdda1e3792987f8.svg";
export { ForwardRef as ReactComponent };